import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { user, globalNavigation, notifications, userGroups } from '../modules/shell/reducers';
import clientsModule from '../modules/clients/reducers';
import clientingModule from '../modules/clienteling/reducers';
import performanceModule from '../modules/performance/reducers';
import globalSearch from '../modules/clients/reducers/globalSearch';
import associateNotifications from '../modules/notifications/reducers';
import productsModule from '../modules/products/reducers';
import recentProductSearch from '../modules/products/reducers/recentProductSearch';
import dismissFeatures from '../modules/home/reducers/newFeatures';
import getOrderStatuses from '../modules/home/reducers/homePage';
import generalManagerStores from '../modules/home/reducers/generalManagerStores';
import managerDateFilter from '../modules/performance/reducers/managerDateFilter';
import alterationsModule from '../modules/alterations/reducers';
import emailPreferences from '../modules/clienteling/reducers/emailPreferences';
import calendarRange from '../modules/performance/reducers/calendarRange';

const appReducer = combineReducers({
  form: formReducer,
  user,
  clientsModule,
  clientingModule,
  performanceModule,
  productsModule,
  globalSearch,
  globalNavigation,
  notifications,
  associateNotifications,
  userGroups,
  recentProductSearch,
  dismissFeatures,
  getOrderStatuses,
  generalManagerStores,
  managerDateFilter,
  alterationsModule,
  emailPreferences,
  calendarRange,
});

export default (state, action) => appReducer(state, action);
